import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class ClientApi {
  getClients = async (params) => {
    try {
      const response = await api.get("client", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Client(s). Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getClientById = async (id) => {
    try {
      const response = await api.get(`client/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Client details. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  saveClient = async (data) => {
    try {
      const response = await api.post("/client", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Save Client. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  updateClient = async (id, data) => {
    try {
      const response = await api.put(`/client/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Client. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  toggleClientStatus = async (id, data) => {
    try {
      const response = await api.put(`/client/status/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Client Status. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  deleteClient = async (id) => {
    try {
      const response = await api.delete(`/client/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Delete Client. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  downloadSample = async (params = {}) => {
    try {
      const response = await api.get("/client/sample-download", {
        responseType: "blob",
        params,
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "client_bulk_upload_sample.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      return { status: true };
    } catch (error) {
      const errorMessage = "Failed to Download Sample. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error };
    }
  };

  bulkUpload = async (formData) => {
    try {
      const response = await api.post("/client/bulk-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorData = error?.response?.data;
      const errorFileUrl = errorData?.data?.errorFileUrl || errorData?.errorFileUrl;
      if (!errorFileUrl) {
        const errorMessage =
          errorData?.message ||
          "Failed to Upload Clients. Please check your data and try again.";
        ShowNotifications.showAlertNotification(errorMessage, false, 15000);
      }
      return { status: false, response: error?.response?.data || error };
    }
  };

  getClientFollowupHistory = async (id, params) => {
    try {
      const response = await api.get(`client/${id}/followups`, { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Client Followup History. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getClientFollowups = async (params) => {
    try {
      const response = await api.get("client/followups/list", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Client Followups. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  updateClientFollowupStatus = async (data) => {
    try {
      const response = await api.post("client/followups/update", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Client Followup Status. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  editStallFinancials = async (data) => {
    try {
      const response = await api.post("client/followups/edit-stall", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Edit Stall Financials. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getClientFollowupPayments = async (followupId) => {
    try {
      const response = await api.get(`client/followups/${followupId}/payments`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Followup Payments. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  verifyPaymentStatus = async (paymentId, status, remarks = "") => {
    try {
      const response = await api.post(`client/payments/${paymentId}/verify`, { status, remarks });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Verify Payment Status. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  submitAdminPayment = async (formData) => {
    try {
      const response = await api.post("client/followups/payments", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit payment. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  submitDirectStallBooking = async (data) => {
    try {
      const response = await api.post("client/followups/block-stall", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit stall booking. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  bulkAssignFollowups = async (data) => {
    try {
      const response = await api.post("client/followups/bulk-assign", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to bulk assign clients. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };
}

const clientApi = new ClientApi();
export default clientApi;

export const {
  getClients,
  getClientById,
  saveClient,
  updateClient,
  toggleClientStatus,
  deleteClient,
  downloadSample,
  bulkUpload,
  getClientFollowupHistory,
  getClientFollowups,
  updateClientFollowupStatus,
  editStallFinancials,
  getClientFollowupPayments,
  verifyPaymentStatus,
  submitAdminPayment,
  submitDirectStallBooking,
  bulkAssignFollowups,
} = clientApi;